import React from 'react';
import { Section } from './ui/Section';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  const scrollToPricing = () => {
    trackEvent('ViewContent', {
      content_name: 'final_cta_click',
      content_category: 'cta'
    });
    const el = document.getElementById('pricing');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <Section data-id="element-90">
      <div className="text-center max-w-3xl mx-auto" data-id="element-91">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-brand-title" data-id="element-92">
          🚀 ¿A qué esperas?
        </h2>
        <p className="font-body text-xl text-brand-subtitle mb-6" data-id="element-93">
          Cada semana que pasa improvisando es una semana de tiempo perdido que
          no vuelve.
        </p>

        <div className="space-y-3 mb-6" data-id="element-94">
          <button onClick={scrollToPricing} className="font-heading bg-gradient-red hover:opacity-90 text-white font-bold text-xl md:text-2xl py-4 px-10 rounded-2xl transition-all hover:scale-105 active:scale-95 shadow-red-glow-lg w-full md:w-auto tracking-wide" data-id="element-95">
            🚀 SÍ, QUIERO EL MANUAL COMPLETO POR 13,99€ →
          </button>
          <p className="font-body text-brand-text text-sm" data-id="element-96">
            6 Tomos + 6 Bonos · Acceso Inmediato · Garantía 7 Días
          </p>
        </div>

        <div className="space-y-3" data-id="element-97">
          <button onClick={scrollToPricing} className="font-heading bg-gradient-red hover:opacity-90 text-white font-bold text-xl md:text-2xl py-4 px-10 rounded-2xl transition-all hover:scale-105 active:scale-95 shadow-red-glow-lg w-full md:w-auto tracking-wide" data-id="element-98">
            🏆 SÍ, QUIERO EL PACK COMPLETO + SALA 365D POR 19,99€ →
          </button>
          <p className="font-body text-brand-text text-sm" data-id="element-99">
            6 Tomos + 6 Bonos + SALA LLENA 365D · La opción más elegida
          </p>
        </div>

        <div className="text-brand-textMuted font-medium text-sm tracking-wide mt-6" data-id="element-100">
          ⚡ Acceso Inmediato • 🛡️ Garantía de 7 Días • 💳 Pago Único • 🔒 Pago
          100% Seguro
        </div>
      </div>
    </Section>;
}